'use client';
import { useQuery } from '@apollo/client';
import { Case } from '@bybeam/platform-types';
import Loading from '@platform-ui-common/components/Loading/index.js';
import Typography from '@platform-ui-common/components/Typography/index.js';
import { ProgramContext } from '@platform-ui-common/hooks/contexts/useProgram.js';
import Color from '@platform-ui-common/utilities/Color.js';
import { useParams } from 'react-router';
import GetCaseQuery from '../../graphql/GetCase.graphql';
import { CaseContext } from '../../hooks/useCase.js';
import CaseDetails from './components/CaseDetails.js';

export default function CaseDetailsComponent(): JSX.Element {
  const { caseId } = useParams<{ caseId: string }>();

  const { data, loading, error, refetch } = useQuery<{ cases: { cases: Case[] } }, { id: string }>(
    GetCaseQuery,
    { variables: { id: caseId } },
  );

  const case_ = data?.cases?.cases?.[0];

  if (loading) return <Loading size="XXL" fullPage />;
  if (error)
    return (
      <Typography variant="body" color={Color.Error}>
        Something went wrong
      </Typography>
    );

  return (
    <ProgramContext.Provider value={case_?.program?.id}>
      <CaseContext.Provider value={{ case_, refetch }}>
        <CaseDetails />
      </CaseContext.Provider>
    </ProgramContext.Provider>
  );
}
